import { Group, Vector3, Geometry, Line, WireframeGeometry, LineBasicMaterial, Color, BufferGeometry, BufferAttribute, MathUtils } from 'three';
import { TWEEN } from 'three/examples/jsm/libs/tween.module.min.js';

class Tower extends Group {
    constructor(parent) {
        // Call parent Group() constructor
        super();

        const material = new LineBasicMaterial( {
	          color: new Color("rgb(220, 200, 50)"),
	          linewidth: 4,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round' //ignored by WebGLRenderer
        } );

        const material2 = new LineBasicMaterial( {
	          color: new Color("rgb(255, 20, 5)"),
	          linewidth: 6,
	          linecap: 'round', //ignored by WebGLRenderer
	          linejoin:  'round' //ignored by WebGLRenderer
        } );

        // Init state
        this.state = {
            pstate: parent.state,
            mat: material,
            charge: 0.0,
            bar1: undefined,
            bar2: undefined,
            spawn: 25,
        };

        var geometry = new Geometry();

	      geometry.vertices.push(new Vector3(0,0,0));
        geometry.vertices.push(new Vector3(2,2,2));
        geometry.vertices.push(new Vector3(-2,2,2));
        geometry.vertices.push(new Vector3(-2,16,2));
        geometry.vertices.push(new Vector3(2,16,2));

        var geometry2 = new Geometry();

	      geometry2.vertices.push(new Vector3(1.5,16,1.5));
        geometry2.vertices.push(new Vector3(-1.5,16,1.5));
        geometry2.vertices.push(new Vector3(-1.5,20,1.5));
        geometry2.vertices.push(new Vector3(1.5,20,1.5));
        geometry2.vertices.push(new Vector3(0,23,0));

        var geometry3 = new Geometry();

        geometry3.vertices.push(new Vector3(-5,24,0));
        geometry3.vertices.push(new Vector3(-5,26,0));
        geometry3.vertices.push(new Vector3(5,26,0));
        geometry3.vertices.push(new Vector3(5,24,0));
        geometry3.vertices.push(new Vector3(-5,24,0));

        var geometry4 = new Geometry();

        geometry4.vertices.push(new Vector3(-4.5,24.5,0));
        geometry4.vertices.push(new Vector3(-4.5,25.5,0));
        geometry4.vertices.push(new Vector3(4.5,25.5,0));
        geometry4.vertices.push(new Vector3(4.5,24.5,0));
        geometry4.vertices.push(new Vector3(-4.5,24.5,0));

        const line1 = new Line(geometry, material);
        const line2 = new Line(geometry, material);
        const line3 = new Line(geometry, material);
        const line4 = new Line(geometry, material);
        const line5 = new Line(geometry2, material);
        const line6 = new Line(geometry2, material);
        const line7 = new Line(geometry2, material);
        const line8 = new Line(geometry2, material);

        const line9 = new Line(geometry3, material);
        const line10 = new Line(geometry4, material2);

        line2.rotation.y = 1.57;
        line3.rotation.y = 3.14;
        line4.rotation.y = -1.57;

        line6.rotation.y = 1.57;
        line7.rotation.y = 3.14;
        line8.rotation.y = -1.57;

        this.add(line1);
        this.add(line2);
        this.add(line3);
        this.add(line4);
        this.add(line5);
        this.add(line6);
        this.add(line7);
        this.add(line8);
        this.add(line9);
        this.add(line10);

        this.state.bar1 = line9;
        this.state.bar2 = line10;

        this.name = "tower";

        this.position.x = MathUtils.randInt(-120, 120);
        this.position.z = MathUtils.randInt(-120, 120);
        this.position.y = 2;
        this.state.pstate.tower.copy(this.position);
        // Add self to parent's update list
        parent.addToUpdateList(this);
    }

    update(timeStamp) {
        var dif = this.position.clone().sub(this.state.pstate.playerPos);
        var angle = Math.atan2(dif.x, dif.z);
        this.state.bar1.rotation.y = 3.14+angle;
        this.state.bar2.rotation.y = 3.14+angle;

        this.state.bar2.geometry.vertices[2].x = -4.5 + this.state.charge/10;
        this.state.bar2.geometry.vertices[3].x = -4.5 + this.state.charge/10;
        this.state.bar2.geometry.verticesNeedUpdate = true;
        this.state.bar2.geometry.dynamic = true;

        if (this.state.charge > this.state.spawn){
            this.state.pstate.waves = this.state.pstate.total_waves;
            this.state.spawn += 25;
        }

        if (this.state.charge > 90){
            this.state.bar1.visible = false;
            this.state.bar2.visible = false;
            this.state.mat.color.r += .01;
            this.state.mat.color.b += .01;
            this.state.mat.color.g += .01;
            this.state.mat.opacity -= .015;
            if (this.state.mat.transparent == false) this.state.pstate.aSound.play();
            else this.state.mat.transparent = true;
            this.position.y += 0.2;
            if (this.state.mat.opacity <= 0.0){
                while(this.position.distanceTo(this.state.pstate.playerPos) < 90){
                    this.position.x = MathUtils.randFloat(-120, 120);
                    this.position.z = MathUtils.randFloat(-120, 120);
                }
                this.state.pstate.powerUp();
                this.position.y = 2;
                this.state.pstate.tower.copy(this.position);
                this.state.mat.color = new Color("rgb(220, 200, 50)");
                this.state.charge = 0;
                this.state.spawn = 25;
                this.state.bar1.visible = true;
                this.state.bar2.visible = true;
                this.state.pstate.mult *= 2;
                this.state.mat.opacity = 1;
                this.state.mat.transparent = false;

            }

        }

        if(dif.length() < 80) this.state.charge += 0.06;
        else if (this.state.charge > 0) this.state.charge -= 0.06;
    }
}

export default Tower;
